export const omit = (obj, omitKey) => {
    const keysToOmit = typeof omitKey === "string" ? [omitKey] : omitKey;
    return Object.keys(obj).reduce((result, key) => {
        if (keysToOmit.indexOf(key) < 0) {
            result[key] = obj[key];
        }
        return result;
    }, {});
};

export const arrayToMap = (array = [], key = null, keyFn = null) => {
    return array.reduce((map, curr) => {
        map[(key && curr[key]) || keyFn(curr)] = curr;
        return map;
    }, {});
};

export const isEnableProperty = property => {
    const propertyValue = JSON.parse(property || 0);
    return Boolean(propertyValue);
};

const objectToString = value => Object.prototype.toString.call(value);

export const isEmpty = value => {
    if (value == null) {
        return true;
    }
    if (Array.isArray(value) || typeof value === "string") {
        return !value.length;
    }
    if (
        objectToString(value) === "[object Map]" ||
        objectToString(value) === "[object Set]"
    ) {
        return !value.size;
    }
    if (objectToString(value) === "[object Object]") {
        return !Object.keys(value).length;
    }
    return false;
};
